import React from "react";
import IPageHeader from "../../models/IPageHeader";
import { EmptyTabletCol } from "../commons/Commons.style";
import { Col, Grid } from "../grid";
import {
  PageHeaderAssetContainerStyle,
  WidePageHeaderContainerStyle,
  PageHeaderDescriptionStyle,
  PageHeaderStyle,
  SlimPageHeaderContainerStyle,
} from "./PageHeader.style";
import GImage, { hasImage } from "../gImage/GImage";

export type ISeparation = "slim" | "wide";

export enum SeparationEnum {
  SLIM = "slim",
  WIDE = "wide",
}

interface IPageHeaderProps {
  pageHeader: IPageHeader;
  separation?: ISeparation;
  borderBottom?: boolean;
}

const PageHeader = ({
  pageHeader: { title, titleDescription, image, imageAlt, publicUrl },
  separation = SeparationEnum.WIDE,
  borderBottom = true,
}: IPageHeaderProps) => {
  const PageHeaderContainerStyle =
    separation === SeparationEnum.WIDE
      ? WidePageHeaderContainerStyle
      : SlimPageHeaderContainerStyle;
  return (
    <PageHeaderContainerStyle borderBottom={borderBottom}>
      <Grid cols={12} columnGap={16} rowGap={0}>
        <EmptyTabletCol />
        <Col xxl={8} xl={10} md={10} sm={12}>
          <PageHeaderStyle>{title}</PageHeaderStyle>
        </Col>
        <EmptyTabletCol />
        <EmptyTabletCol />
        <Col xxl={6} xl={8} md={10} sm={12}>
          {titleDescription && (
            <PageHeaderDescriptionStyle>
              {titleDescription}
            </PageHeaderDescriptionStyle>
          )}
        </Col>
      </Grid>
      {hasImage({ image, publicUrl }) && (
        <Grid cols={12} columnGap={16} rowGap={0}>
          <Col xxl={12}>
            <PageHeaderAssetContainerStyle>
              <GImage
                imageInfo={{
                  image,
                  imageAlt,
                  publicUrl,
                }}
              />
            </PageHeaderAssetContainerStyle>
          </Col>
        </Grid>
      )}
    </PageHeaderContainerStyle>
  );
};

export default PageHeader;
